// Generated by purs version 0.13.0
"use strict";
var Chip_Model_Direction = require("../Chip.Model.Direction/index.js");
var adjustPoint = function (v) {
    return function (direction) {
        if (direction instanceof Chip_Model_Direction.Up) {
            return {
                x: v.x,
                y: v.y - 1 | 0
            };
        };
        if (direction instanceof Chip_Model_Direction.Left) {
            return {
                x: v.x - 1 | 0,
                y: v.y
            };
        };
        if (direction instanceof Chip_Model_Direction.Down) {
            return {
                x: v.x,
                y: v.y + 1 | 0
            };
        };
        if (direction instanceof Chip_Model_Direction.Right) {
            return {
                x: v.x + 1 | 0,
                y: v.y
            };
        };
        throw new Error("Failed pattern match at Chip.Mutation.Point (line 10, column 34 - line 14, column 27): " + [ direction.constructor.name ]);
    };
};
module.exports = {
    adjustPoint: adjustPoint
};
